var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "700" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { "min-width": "50%" } },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2 pa-0",
                  attrs: { icon: "", color: "red" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _vm._l(_vm.getAudiences(), function (audience) {
                    return [
                      _c("v-checkbox", {
                        key: audience.name,
                        style: {
                          "margin-right": "10px",
                          "margin-top": "-10px",
                          "margin-bottom": "10px",
                        },
                        attrs: {
                          color: "blue",
                          label: audience.name.toUpperCase(),
                          value: audience.name,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.check(audience.name)
                          },
                        },
                        model: {
                          value: _vm.selected[audience.name],
                          callback: function ($$v) {
                            _vm.$set(_vm.selected, audience.name, $$v)
                          },
                          expression: "selected[audience.name]",
                        },
                      }),
                    ]
                  }),
                ],
                2
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _vm._l(_vm.getCustomAudiences(), function (audience) {
                    return [
                      _c("v-checkbox", {
                        key: audience.name,
                        style: {
                          "margin-right": "25px",
                          "margin-top": "-10px",
                          "margin-bottom": "10px",
                        },
                        attrs: {
                          color: "red",
                          label: audience.name.toUpperCase(),
                          value: audience.name,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.check(audience.name)
                          },
                        },
                        model: {
                          value: _vm.selected[audience.name],
                          callback: function ($$v) {
                            _vm.$set(_vm.selected, audience.name, $$v)
                          },
                          expression: "selected[audience.name]",
                        },
                      }),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticStyle: { "margin-top": "-25px" } },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2 white--text",
                  attrs: {
                    loading: _vm.buttonLoading,
                    elevation: "0",
                    disabled: _vm.config == null,
                    color: "blue",
                  },
                  on: { click: _vm.onPressDeploy },
                },
                [_vm._v("DEPLOY ")]
              ),
              _c("v-spacer"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }